import LabelField from '@app/components/atoms/LabelField/LabelField'
import Section from '@app/components/atoms/Section/Section'
import { yupResolver } from '@hookform/resolvers/yup'
import { Inertia } from '@inertiajs/inertia'
import { InertiaLink } from '@inertiajs/inertia-react'
import { Button, Grid, TextField } from '@mui/material'
import Autocomplete from '@mui/material/Autocomplete'
import { styled } from '@mui/material/styles'
import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import PosCreateSchema from './PosCreateSchema'

const ButtonCustom = styled(Button)({
  marginTop: 20,
  marginRight: 20,
})
const GridCustomizer = styled(Grid)({
  marginBottom: '5%',
})

export default function PosCreate({ merchants }) {
  const { t } = useTranslation()
  const [disabled, setDisabled] = useState(false)

  const initialValues = {
    name: '',
    address: '',
    city: '',
    longitude: '',
    latitude: '',
    merchant: '',
    merchant_id: null,
  }

  Inertia.on('finish', () => setDisabled(false))

  const onSubmit = (data) => {
    setDisabled(true)
    Inertia.post(route('admin.pos.store'), data, {
      onError: (errors) => {
        setError('longitude', { message: t(errors.longitude) })
        setError('latitude', { message: t(errors.latitude) })
      },
    })
  }

  const {
    register,
    trigger,
    handleSubmit,
    setValue,
    setError,
    formState: { errors },
  } = useForm({
    mode: 'onBlur',
    defaultValues: initialValues,
    resolver: yupResolver(PosCreateSchema),
  })

  return (
    <GridCustomizer container spacing={2}>
      <Grid item xs={12}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Section title={t('POS.BASIC_INFORMATION')}>
                <Grid item lg={7} md={12} sm={12} xs={12}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <LabelField required title={t('POS.NAME')}>
                        <TextField
                          fullWidth
                          name="name"
                          {...register('name')}
                          error={errors.name ? true : false}
                          helperText={errors.name?.message}
                          size="small"
                          type="text"
                          variant="outlined"
                          onFocus={() => trigger('name')}
                        />
                      </LabelField>
                    </Grid>

                    <Grid item xs={12}>
                      <LabelField required title={t('POS.ADDRESS')}>
                        <TextField
                          fullWidth
                          name="address"
                          {...register('address')}
                          error={errors.address ? true : false}
                          helperText={errors.address?.message}
                          size="small"
                          type="text"
                          variant="outlined"
                          onFocus={() => trigger('address')}
                        />
                      </LabelField>
                    </Grid>

                    <Grid item xs={12}>
                      <LabelField required title={t('POS.CITY')}>
                        <TextField
                          fullWidth
                          name="city"
                          size="small"
                          type="text"
                          {...register('city')}
                          error={errors.city ? true : false}
                          helperText={errors.city?.message}
                          variant="outlined"
                          onFocus={() => trigger('city')}
                        />
                      </LabelField>
                    </Grid>

                    <Grid item xs={12}>
                      <LabelField required title={t('POS.LONGITUDE')}>
                        <TextField
                          fullWidth
                          {...register('longitude')}
                          error={errors.longitude ? true : false}
                          helperText={errors.longitude?.message}
                          name="longitude"
                          size="small"
                          variant="outlined"
                          onFocus={() => trigger('longitude')}
                        />
                      </LabelField>
                    </Grid>

                    <Grid item xs={12}>
                      <LabelField required title={t('POS.LATITUDE')}>
                        <TextField
                          fullWidth
                          {...register('latitude')}
                          error={errors.latitude ? true : false}
                          helperText={errors.latitude?.message}
                          name="latitude"
                          size="small"
                          variant="outlined"
                          onFocus={() => trigger('latitude')}
                        />
                      </LabelField>
                    </Grid>
                  </Grid>
                </Grid>
              </Section>
            </Grid>

            <Grid item xs={12}>
              <Section title={t('POS.MERCHANT')}>
                <Grid item lg={7} md={12} sm={12} xs={12}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <LabelField title={t('POS.CHOOSE_MERCHANT')}>
                        <Autocomplete
                          getOptionLabel={(option) => option.name}
                          id="merchant_id"
                          isOptionEqualToValue={(option, value) => option.id === value.id}
                          options={merchants}
                          renderInput={(params) => (
                            <TextField
                              fullWidth
                              {...params}
                              size="small"
                              variant="outlined"
                              {...register('merchant')}
                              error={errors.merchant ? true : false}
                              helperText={errors.merchant?.message}
                            />
                          )}
                          onChange={(e, value) => {
                            setValue('merchant_id', value?.id ?? '')
                          }}
                        />
                      </LabelField>
                    </Grid>
                  </Grid>
                </Grid>
              </Section>
            </Grid>

            <Grid item xs={12}>
              <ButtonCustom disabled={disabled} type="submit" variant="contained">
                {t('BUTTON.SAVE')}
              </ButtonCustom>
              <ButtonCustom color="inherit" component={InertiaLink} href={route('admin.pos.index')} variant="contained">
                {t('BUTTON.CANCEL')}
              </ButtonCustom>
            </Grid>
          </Grid>
        </form>
      </Grid>
    </GridCustomizer>
  )
}
